import { useMemo } from 'react';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';

interface NotesFormProps {
  title: string;
  placeholder?: string;
  hasNotary: boolean;
  formTitle?: string;
}
export const useDetermineNotesFormProps = (wizardFormData: CreateSigningAppointmentFormData) => {
  return useMemo((): NotesFormProps => {
    switch (wizardFormData.signingMethod) {
      case eSigningMethod.wetSign:
        return { title: 'Wet Signing Notes', hasNotary: false };
      case eSigningMethod.attorney:
        return {
          title: 'Attorney Partner',
          placeholder: 'Enter Attorney/Law Practice in this section.',
          hasNotary: true,
          formTitle: 'Add Attorney Partner',
        };
      case eSigningMethod.ron:
        return {
          title: 'Notary',
          placeholder: 'Enter Remote Online Notary (RON) provider in this section.',
          hasNotary: true,
          formTitle: 'Add Notary',
        };
      default:
        return { title: 'Notes', hasNotary: false };
    }
  }, [wizardFormData]);
};
